<template>
    <div class="Experimentlist">
        <el-row>
            <el-col :xs="24" :sm="24" :lg="24" :xl="24">
                <div class="contentl">
                    <p class="tit">
                        我的考评
                    </p>
                    <div class="break" style="font-size:14px;margin-left:20px;margin-bottom:15px;float:left;margin-top:28px;"><span>{{eduName}}</span></div>
                    <ul>
                        <li>
                        <el-input placeholder="输入实验名称进行搜索" clearable v-model="search" @keyup.enter.native="searchto" class="input-with-select" v-if="inpu" @change="closeSearch">
                                <el-button slot="append" @click="searchto"><i class="magnifier"></i></el-button>
                                <el-button slot="append" @click="Rescreening" style="border-left:1px solid #DCDFE6;"><i class="refresh"></i></el-button>
                        </el-input>
                        <el-input placeholder="输入实验名称进行搜索" clearable v-model="search" @keyup.enter.native="searchto2" class="input-with-select" v-if="inpu2" @change="closeSearch2">
                                <el-button slot="append" @click="searchto2"><i class="magnifier"></i></el-button>
                                <el-button slot="append" @click="Rescreening2" style="border-left:1px solid #DCDFE6;"><i class="refresh"></i></el-button>
                        </el-input>
                        </li>
                    </ul>
                </div>
            </el-col>
        </el-row>
        <el-row style="margin:4px 10px 10px 10px;">
            <el-col :xs="24" :sm="24" :lg="24" :xl="24">
                <div class="list" v-if="itemOK">
                    <div class="noshow" v-if="dataList == ''">
                        <span>点击右上角【创建实验】按钮，创建自己的实验</span>
                        <p><img src="../../assets/images/portal/noex.png" alt=""></p>
                    </div>
                    <el-row :gutter="20" v-else>
                        <el-col :xs="12" :sm="8" :lg="8" :xl="8" class="item" v-for="(item,index) in dataList" :key="index" v-loading="loading">
                            <div class="itemIn">
                                <div class="pic">
                                    <p class="upstrata" v-if="item.isStudy == 2 || item.isStudy == 1"><el-button type="text" class="startgame" @click="infoex(item)">开始实验</el-button></p>
                                    <p class="upstrataS" v-if="item.isStudy == 2 || item.isStudy == 1"><el-button type="text" class="startgameS" @click="saveEx(item)">开始考试</el-button></p>
                                    <el-image fit="cover" :src="imageChanges[index]" :title="item.syname" style="background-color:#1d1d1d;">
                                        <div slot="error" class="image-slot">
                                            <img src="../../assets/images/portal/nophoto.png">
                                        </div>
                                    </el-image>
                                    <div class="tbtj" :class="{'box3':item.isStudy == 2}" v-if="item.isStudy != null">
                                        <b class="left-top">{{item.isStudy | isStudy}}</b>
                                    </div>
                                    <div v-else></div>
                                </div>
                                <div class="pick">
                                    <h5 class="titl" :title="item.syname" v-if="ReExNameId != item.id">{{item.syname}}</h5>
                                    <h5 class="titl" :title="item.syname" v-if="ReNames && ReExNameId == item.id">{{item.syname}}</h5>
                                </div>
                            </div>
                        </el-col>
                        <div class="paginations" v-if="pagin">
                            <el-pagination
                                background
                                hide-on-single-page
                                layout="prev, pager, next"
                                :total="pageData.total"
                                @current-change="pageChange"
                                :current-page.sync="page"
                                :page-size='12'
                                >
                            </el-pagination>
                        </div>
                        <div class="paginations" v-if="pagin2">
                            <el-pagination
                                background
                                hide-on-single-page
                                layout="prev, pager, next"
                                :total="pageData.total"
                                @current-change="pageChange2"
                                :current-page.sync="page"
                                :page-size='12'
                                >
                            </el-pagination>
                        </div>
                    </el-row>
                </div>
            </el-col>
        </el-row>
        <div id="unitybox" v-if="unityex">
            <div id="bo">
            <div id="buttombox" v-if="isPad">
                <el-tooltip class="items" effect="light" :popper-class="toolTipClass" content="关闭实验" placement="right" :open-delay="200">
                    <p id="closeun" @click="closeuni" style="cursor: pointer;float:left"><i><img src="../../assets/images/portal/close.png" alt=""></i></p>
                </el-tooltip>
                <el-tooltip class="items" effect="light" :popper-class="toolTipClass" content="全屏显示" placement="right" :open-delay="200">
                    <div id="full" @click="fullSrc" style="cursor: pointer;float:left"><i><img src="../../assets/images/portal/full.png" alt=""></i></div>
                </el-tooltip>
            </div>
            <div id="buttombox" v-if="isPad2">
                <p id="closeun" @click="closeuni" style="cursor: pointer;float:left"><i><img src="../../assets/images/portal/close.png" alt=""></i></p>
            </div>
            <!-- 同步实验 -->
                <iframe id="ifrunity" v-if="this.ExIsStudy == 0" frameborder=0 scrolling=auto allowtransparency="true" :src=" this.resourceURL +'?'+'UID='+this.experimentuid+'&Authorization='+$store.state.user.token+'&SyName='+this.experimentcode+'&config='+this.config"></iframe>
            <!-- 探究实验 -->
                <iframe id="ifrunity" v-else-if="this.ExIsStudy == 1" frameborder=0 scrolling=auto allowtransparency="true" :src=" this.resourceURL +'?'+'UID='+this.experimentuid+'&Authorization='+$store.state.user.token+'&SyName='+this.experimenttit+'&config='+this.config+'&userid='+this.userId+'&syID='+this.syID+'&modularBarU='+this.modularBarU+'&userVIP='+this.userVIP+'&TreeNodes='+this.TreeNodes+'&ChapterNodes='+this.ChapterNodes+'&Treeid='+this.Treeid+'&Chapterid='+this.Chapterid+'&userState='+this.userState+'&isStudy='+this.ExIsStudy"></iframe>
            <!-- 我的实验 -->
                <iframe id="ifrunity" v-else-if="this.ExIsStudy == 2" frameborder=0 scrolling=auto allowtransparency="true" :src=" this.resourceURL +'?'+'&Authorization='+$store.state.user.token+'&SyName='+ this.exName2+'&config='+this.config+'&userid='+this.userId+'&syID='+this.syID+'&modularBarU='+this.modularBarU+'&userVIP='+this.userVIP+'&TreeNodes='+this.TreeNodes+'&ChapterNodes='+this.ChapterNodes+'&Treeid='+this.Treeid+'&Chapterid='+this.Chapterid+'&userState='+this.userState+'&isStudy='+this.ExIsStudy+'&sypid='+this.folderId"></iframe>
            </div>
        </div>
        <transition name="el-zoom-in-center">
            <div class="boxxx" v-if="boxEx">
                <div class="transition-box">
                    <div class="head">创建实验<p @click="closea"><img src="../../assets/images/newimg/close.png" alt=""></p></div>
                    <div class="content">
                        <ul>
                            <li>实验名称：<el-input class="Exinput" v-model="exName" placeholder="请输入实验名称"></el-input></li>
                            <li>实验模块：
                                <el-radio-group v-model="modular" size="mini">
                                    <el-radio label="1" border>电学</el-radio>
                                    <el-radio label="2" border>力学</el-radio>
                                    <el-radio label="3" border>光学</el-radio>
                                    <el-radio label="4" border>化学</el-radio>
                                </el-radio-group>
                            </li>
                            <!-- <li>关键词：<el-input v-model="exCrux" placeholder="请输入关键词"></el-input></li> -->
                            <li>添加知识点属性：
                                <el-button class="joinEx" @click="getData(filedR)">添加<i class="el-icon-plus" style="margin-left:4px;"></i></el-button>
                                    <el-cascader
                                        :checkStrictly="true"
                                        ref="scalectz"
                                        v-model="filedR.label"
                                        :options="data"
                                        :props="defaultProps"
                                        @change="change"
                                        :change-on-select="true"
                                    >
                                    </el-cascader>
                                    <el-button class="joinEx" type="text" style="color:#ccc">删除</el-button>
                                <!-- <template slot-scope="scope"> -->
                                <div v-for="(item,index) in filedR" :key="index">
                                    <el-cascader
                                        :checkStrictly="true"
                                        ref="scal"
                                        v-model="item.label"
                                        :options="data"
                                        :props="defaultProps"
                                        @change="change22(item,index)"
                                        :change-on-select="true"
                                        >
                                    </el-cascader>
                                    <el-button class="joinEx" type="text" @click="del(index)">删除</el-button>
                                </div>
                                <!-- </template> -->
                                <!-- <el-tree
                                    v-loading="loading"
                                    :data="data"
                                    show-checkbox
                                    accordion
                                    ref="treez"
                                    check-strictly
                                    node-key="id"
                                    :props="defaultProps"
                                    @check-change="handleNodeClickz">
                                </el-tree> -->
                            </li>
                            <li>添加章节属性：
                                <el-button class="joinEx" @click="getData2(filedR2)">添加<i class="el-icon-plus" style="margin-left:4px;"></i></el-button>
                                    <el-cascader
                                        :checkStrictly="true"
                                        ref="scalectj"
                                        v-model="filedR2.label"
                                        :options="data2"
                                        :props="defaultProps2"
                                        @change="change2"
                                        :change-on-select="true"
                                        >
                                    </el-cascader>
                                    <el-button class="joinEx" type="text" style="color:#ccc">删除</el-button>
                                <div v-for="(item,index) in filedR2" :key="index">
                                    <el-cascader
                                        :checkStrictly="true"
                                        ref="scal2"
                                        v-model="item.label"
                                        :options="data2"
                                        :props="defaultProps2"
                                        @change="change32(item,index)"
                                        :change-on-select="true"
                                        >
                                    </el-cascader>
                                    <el-button class="joinEx" type="text" @click="del2(index)">删除</el-button>
                                </div>
                                <!-- <el-tree
                                    v-loading="loading"
                                    :data="data2"
                                    show-checkbox
                                    check-strictly
                                    accordion
                                    ref="treej"
                                    node-key="id"
                                    :props="defaultProps2"
                                    @check-change="handleNodeClickj">
                                </el-tree> -->
                            </li>
                            <li>
                                <el-input placeholder="请输入内容" v-model="input3" class="input-with-select">
                                    <el-upload
                                        class="upload-demo"
                                        action="https://www.mocky.io/v2/5185415ba171ea3a00704eed/posts/"
                                        :limit="1"
                                        :before-upload="uploadMultipartFile"
                                        :on-preview="handlePreview"
                                        :on-remove="handleRemove">
                                        <el-button size="small" type="primary">选择封面</el-button>
                                    </el-upload>
                                </el-input>
                            </li>
                            <li>
                                <el-button :loading="loading" type="warning" @click="preserCon">确定</el-button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="boxxx" v-if="Folder">
                <div class="transition-box">
                    <div class="head">新建文件夹<p @click="closeF"><img src="../../assets/images/newimg/close.png" alt=""></p></div>
                    <div class="content">
                        <ul>
                            <li>文件夹名称：<el-input class="Exinput" v-model="FolderTitle" placeholder="请输入文件夹名称"></el-input></li>
                            <li style="margin-bottom:25px;">当前路径:
                                <span style="width:100%;float:left;margin-top:7px;color:#666666;" v-if="this.eduName != ''">{{eduName}}</span>
                                <ol class="folderR" v-else>
                                    <li>全部</li>
                                    <li v-for="(item,index) in indexparent" :key="index"><span>&nbsp;/&nbsp;</span>{{item.syname}}</li>
                                </ol>
                            </li>
                            <li>
                                <el-button :loading="loadingF" class="joinBtn" type="warning" @click="determineFolder">确定</el-button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="boxxx" v-if="FolderM">
                <div class="transition-box">
                    <div class="head">移动路径<p @click="closeM"><img src="../../assets/images/newimg/close.png" alt=""></p></div>
                    <div class="content">
                        <ul style="width:100%">
                            <li style="margin-bottom:25px;">移动路径目录:
                                <el-tree :data="dataFT" highlight-current :props="defaultPropsFT" @node-click="handleNodeClickFT" v-loading="loading" style="margin-top:6px;"></el-tree>
                            </li>
                            <li>
                                <el-button :loading="loadingM" class="joinBtn" type="warning" @click="determineFolderM">确认移动</el-button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import request from '@/utils/request'
import { parseTime } from '@/utils/index'
import $ from 'jquery'

export default {
    // props:['src'],
    data(){
        return{
            input3: '',
            isPad:true,
            isPad2:false,
            ReNames:false,
            loadingFolder:false,
            userChoice:'',
            defaultPropsFT: {
                children: 'children',
                label: 'syname'
            },
            dataFT:[{}],
            folderId:'',
            noderes:0,
            loadingF:false,
            loadingM:false,
            FolderTitle:'新建文件夹',
            Folder:false,
            FolderM:false,
            userState:'',
            experimenttit:'',
            experimentcode:'',
            experimentuid:'',
            ExIsStudy:'',
            Treeid:'',
            TreeNodes:'',
            Chapterid:'',
            ChapterNodes:'',
            userVIP:'',
            vip:false,
            changeNum:'',
            modularBarU:'',
            itemOK:false,
            filedR:[],
            filedR2:[],
            syID:0,
            config:'',
            //tooltip提示文字
            toolTipClass: 'page-login-toolTipClass',
            appIDX:'',
            strReady:'',
            titleNameKey:'',
            // el-tree
            eduIdj:0,
            eduIdz:0,
            ed:[],
            ed2:[],
            data: [],
            cascaderz:[],
            data2: [],
            nums:0,
            nums2:0,
            defaultProps: {
                value:'id',
                children: 'children',
                label: 'chapterName'
            },
            defaultProps2: {
                value:'id',
                children: 'children',
                label: 'chapterName'
            },
            // 实验模块分类栏
            modularBar:"",
            // 实验模块
            modular:"1",
            // 添加实验
            exName:'',
            unityex:false,
            // 实验弹框
            boxEx:false,
            isStudy:'',
            userId:0,
            resourceURL:'',
            star:'collection-2',
            // url:'https://i.loli.net/2019/07/31/5d40fc0c0704d86318.png',
            errorUserPhoto:'https://i.loli.net/2019/07/31/5d40ffb611a2f82333.png',
            page:0,
            loading:false,
            radio1:'全部',
            swit:false,
            swit2:false,
            inpu:false,
            inpu2:false,
            pagin:false,
            pagin2:false,
            isfree:'',
            search: '',
            themeType:'',
            materialType:'',
            infoNumber:'',
            // type:'',
            dataList:[{}],
            eduId:'',
            eduName:'',
            pageData:{
                currentPage:1,
                pagesize:12,
                pagenumber:0,
                total:0,
                average:0,
            },
            isVIP:'',
            codeNum:'',
            timeType:'',
      }
    },
　　filters: {
        isCollectFees: function (value) {
            if(value==0){
                return '免费'
            }else if(value==1){
                return '收费'
            }
        },
        isStudy: function (value) {
            if(value==0){
                return '同步'
            }else if(value==1){
                return '探究'
            }else{
                return '探究'
            }
        },
        isRecomm: function (value) {
            if(value==0){
                return '推荐'
            }else if(value==1){
                return '不推荐'
            }
        },
　　},
    created(){
        this.getinfo();
        this.getConfig();
        this.getTrees();
        this.getChapterTrees();
    },
    // beforeDestroy(){
    //     this.offAllListen();
    // },
    methods:{
        // 封面
        uploadMultipartFile(file){
            let fd = new FormData();
            fd.append('file',file);//传文件
            request({
                method:'post',
                url:'api/uploadMultipartFile',
                data:fd
            }).then(res=>{
                if(res.code != 200){
                    this.$message({
                        message:'Logo图片上传失败,请重新选择图片',
                        type:'error'
                    })
                    this.handleRemove()
                }else{
                    this.$message({
                        message:'Logo图片选择成功',
                        type:'success'
                    })
                    this.tenantLogo = res.data
                }
            })
        },
        handlePreview(file) {
        },
        handleRemove(file) {
        },
        // 全部
        backAll(){
            this.folderId = '';
            if(this.noderes == 0){
                this.getList();
            }else{
                this.getList2();
            }
        },
        // 新建文件夹
        determineFolder(){
          if(this.FolderTitle == ''){
              this.$notify({
                  message:'您还未填写文件夹名称哦！',
                  type:'error',
                  duration: 1500
              })
          }else{
            this.loadingF = true
            let folder = {};
            folder.syname = this.FolderTitle
            if(this.indexparent == '' || this.indexparent == undefined || this.indexparent == null){
                folder.sypid = 0
            }else{
                folder.sypid = this.indexparent.pop().id
            }
            if(this.noderes == 0){
                this.treeId =  this.eduId
                this.chapterId =  0
            }
            if(this.noderes == 1){
                this.treeId =  0
                this.chapterId =  this.eduId
            }
            request({
                url: 'api/createSyfolder?treeId='+this.treeId+'&chapterId='+this.chapterId,
                method: 'post',
                data: folder
            }).then(res=>{
                this.loadingF = false
                if(res.code == 200){
                    this.$notify({
                        message:'新建文件夹成功',
                        type:'success',
                        duration: 1500
                    });
                    this.FolderTitle = '新建文件夹';
                    this.Folder = false;
                    if(this.noderes == 0){
                        this.getList();
                    }else{
                        this.getList2();
                    }
                }
            }).catch(err=>{
                this.loadingF = false
                this.$notify({
                    message:'新建文件夹失败，请重试',
                    type:'error',
                    duration: 1500
                })
            })
          }
        },
        // 关闭
        closeF(){
            this.Folder = false;
            this.FolderTitle = '新建文件夹';
            this.loadingF = false;
        },
        closeM(){
            this.FolderM = false;
            this.loadingM = false;
            this.userChoice = '';
        },
        handleNodeClickFT(data,index) {
            this.userChoice = data.id
        },
        // 清空搜索框-知识点
        closeSearch(val){
            if(val == ''){
                this.searchto();
            }
        },
        // 清空搜索框-章节
        closeSearch2(val){
            if(val == ''){
                this.searchto2();
            }
        },
        parseTime,
        // 编辑实验
        saveEx(item){
            let today = new Date().getTime();
            request({
                method:'get',
                url:'auth/info'
            }).then(res=>{
                this.isVIP = res.jwtUser.vipTerm
                if(document.body.clientWidth < 1024){
                    this.isPad2 = true;
                    this.isPad = false;
                }
                if(this.isVIP > today){
                    if(this.userVIP == 1){
                        this.ExIsStudy = item.isStudy
                        if(item.isStudy == 2 || item.isStudy == 1){
                            this.userState = 1
                            this.syID = item.id
                            this.userId = this.userId
                            this.exName2 = item.syname
                            this.unityex = true
                            this.modularBarU = item.syModular
                            this.getEx()
                            this.randomString(32);
                        // }else if(item.isStudy == 1){
                            // this.syID = item.id
                            // this.userId = this.userId
                            // this.exName2 = item.syname
                            // this.unityex = true
                            // this.modularBarU = item.syModular
                            // this.getEx()
                        }else if(item.isStudy == 0){
                            this.syID = item.resourceId
                            this.unityex = true
                            this.getEx()
                            this.randomString(32);
                        }
                    }else{
                        this.$notify({
                            message:'您尚未加入会员！请联系管理员',
                            type:'error',
                            duration: 1500
                        })
                    }
                }else if(this.isVIP == today){
                    this.$notify({
                        message:'您尚未加入会员！请联系管理员',
                        type:'error',
                        duration: 1500
                    })
                }else if(this.isVIP < today){
                    this.$notify({
                        message:'您尚未加入会员！请联系管理员',
                        type:'error',
                        duration: 1500
                    })
                }else{
                    this.$notify({
                        message:'您尚未加入会员！请联系管理员',
                        type: 'error',
                        duration: 1500
                    });
                }
            });
        },
        // 实验模块
        exModule(value){
            this.modularBar = value
            if(this.changeNum == 0){
                this.getList3()
            }else if(this.changeNum == 1){
                this.getList()
            }else if(this.changeNum == 2){
                this.getList2()
            }
        },
        cc2(){
            if(this.ed2 == ""){
                let num2 = this.eduIdj
                this.nums2 = num2
            }else{
                let num2 = this.eduIdj + ',' + this.ed2
                this.nums2 = num2
            }
            // if(this.eduIdj == ""){
            //     let num2 = this.ed2
            //     this.nums2 = num2
            // }else{
            //     let num2 = this.eduIdj + ',' + this.ed2
            //     this.nums2 = num2
            // }
        },
        cc(){
            if(this.ed == ""){
                let num = this.eduIdz
                this.nums = num
            }else{
                let num = this.eduIdz + ',' + this.ed
                this.nums = num
            }
            // if(this.eduIdz == ""){
            //     let num = this.ed
            //     this.nums = num
            // }else{
            //     let num = this.eduIdz + ',' + this.ed
            //     this.nums = num
            // }
        },
        change22(item,index){
            let sszz = this.$refs.scal[index].getCheckedNodes()[0].value
            this.ed = sszz
            this.cc()
        },
        change32(item,index){
            let sszz2 = this.$refs.scal2[index].getCheckedNodes()[0].value
            this.ed2 = sszz2
            this.cc2()
        },
        // 知识点选择
        change(value){
            let ss = this.$refs.scalectz.getCheckedNodes()[0].value
            this.eduIdz = ss
            this.cc()
        },
        // 章节选择
        change2(value){
            let ss2 = this.$refs.scalectj.getCheckedNodes()[0].value
            this.eduIdj = ss2
            this.cc2()
        },
        // 知识点选择
        getData(filedR){
            if(filedR.length>0){
                this.$notify({
                    message: '知识点只能添加两个哦！',
                    type:'error',
                    duration: 1500
                })
            }else{
                this.filedR.push({})
            }
        },
        // 章节选择
        getData2(filedR2){
            if(filedR2.length>0){
                this.$notify({
                    message: '章节只能添加两个哦！',
                    type:'error',
                    duration: 1500
                })
            }else{
            this.filedR2.push({})
            }
        },
        // 知识点选择
        del(index){
            this.ed = '';
            this.cc();
            this.filedR.splice(index,1);
        },
        // 章节选择
        del2(index){
            this.ed2 = '';
            this.cc2();
            this.filedR2.splice(index,1);
        },
        // 全屏显示
        fullSrc(element){
            var element = document.getElementById("ifrunity");
            if(element.requestFullscreen){
                return element.requestFullscreen();
            }else if(element.webkitRequestFullScreen){
                return element.webkitRequestFullScreen();
            }else if(element.mozRequestFullScreen){
                return element.mozRequestFullScreen();
            }else{
                return element.msRequestFullscreen();
            }
            // var element = document.getElementById("ifrunity");
            // element.requestFullscreen();
        },
        // 关闭实验
        closeuni(){
            this.$confirm('此操作将关闭当前实验, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                cancelButtonClass: 'messageBox-btnF',
                confirmButtonClass: 'messageBox-btnT',
                type: 'warning',
            }).then(() => {
                this.unityex = false;
                this.getList3();
                this.timeType = 1
                this.getExIntervalTime();
            }).catch(() => {
                this.unityex = true;
            })
        },
        // 获取config信息
        getConfig(){
            request({
                method:'get',
                url:'api/getConfiguration?'+'version=v1.1'
            }).then(res=>{
                if(res.code == 200){
                    this.config = res.data
                }else{
                    this.$notify({
                        message: 'config获取失败',
                        type: 'error',
                        duration: 1500
                    })
                }
            })
        },
        // 获取实验信息
        getEx(){
            request({
                method:'get',
                url:'api/jdResources/'+this.syID+'?isStudy='+this.ExIsStudy
            }).then(res=>{
                this.resourceURL = res.data.resourceURL
                this.experimentuid = res.data.jdresource.uid
                this.experimentcode = res.data.jdAppList.code
                this.experimenttit = res.data.jdAppList.title
                // 获取知识点
                this.Treeid = []
                this.TreeNodes = []
                for(let i in res.data.Tree){
                    this.Treeid.push(res.data.Tree[i].id)
                    this.TreeNodes.push(res.data.Tree[i].name)
                }
                // 获取章节
                this.Chapterid = []
                this.ChapterNodes = []
                for(let i in res.data.jdchaptertree){
                    this.Chapterid.push(res.data.jdchaptertree[i].id)
                    this.ChapterNodes.push(res.data.jdchaptertree[i].name)
                }
                // console.log(this.Treeid +"||"+ this.TreeNodes +"||"+ this.Chapterid +"||"+ this.ChapterNodes)
            })
        },
        randomString(len) {
        　　len = len || 32;
            let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
        　　let maxPos = $chars.length;
        　　let pwd = '';
        　　for (let i = 0; i < len; i++) {
        　　　　pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
        　　}
            this.codeNum = pwd
            if(this.codeNum !== ''){
                this.timeType = 0
                this.getExIntervalTime();
            }
        },
        getExIntervalTime(){
            request({
                url:"api/resourcePlay?code="+this.codeNum+"&resourceid="+this.syID+"&type="+this.timeType,
                method:"post"
            }).then(res=>{
            })
        },
        // 点击实验
        infoex(item){
            this.ExIsStudy = item.isStudy
            if(document.body.clientWidth < 1024){
                this.isPad2 = true;
                this.isPad = false;
            }
            if(item.isStudy == 2 || item.isStudy == 1){
                this.userState = 0
                this.syID = item.id
                this.userId = this.userId
                this.exName2 = item.syname
                this.unityex = true
                this.modularBarU = item.syModular
                this.getEx()
                this.randomString(32);
            // }else if(item.isStudy == 1){
                // this.syID = item.id
                // this.userId = this.userId
                // this.exName2 = item.syname
                // this.unityex = true
                // this.modularBarU = item.syModular
                // this.getEx()
            }else if(item.isStudy == 0){
                this.syID = item.resourceId
                this.unityex = true
                this.getEx()
                this.randomString(32);
            }
        },
        //获取侧边栏:按知识点
        getTrees(){
            var _this = this;
            _this.loading=true;
            request({
                url: 'api/trees/trees?'+'noderes=0',
                methods: 'get'
            }).then(function(res){
                _this.data = res.data;
                _this.loading=false
            })
        },
        //获取侧边栏:章节
        getChapterTrees(){
            var _this = this;
            _this.loading=true;
            request({
                url: 'api/chaptertrees/chaptertrees?'+'noderes=0',
                methods: 'get'
            }).then(function(res){
                _this.data2 = res.data;
                _this.loading=false
            })
        },
        //   知识点
        handleNodeClickz() {
          this.eduIdz = []
            let takeDate = this.$refs.treez.getCheckedNodes();
            for(let i in takeDate){
                this.eduIdz.push(takeDate[i].id)
            }
        },
        //   章节
        handleNodeClickj() {
          this.eduIdj = []
            let takeDate = this.$refs.treej.getCheckedNodes();
            for(let i in takeDate){
                this.eduIdj.push(takeDate[i].id)
            }
        },
        // 保存实验信息
        preserCon(){
          if(this.exName == ''){
              this.$notify({
                  message:'您还未填写实验名称哦！',
                  type:'error',
                  duration: 1500
              })
          }else{
            this.loading = true
            if(true){
                request({
                    method:'post',
                    url:'api/Oauth/GetKey'
                }).then(res=>{
                    if(res.code == 400){
                        this.$notify({
                            message: '创建实验有误，请联系管理员',
                            type: 'error',
                            duration: 1500
                        })
                        this.eduIdz = 0
                        this.eduIdj = 0
                        this.exName = ''
                        this.filedR.label = 0
                        this.filedR2.label = 0
                        this.nums = 0;
                        this.nums2 = 0;
                        this.del();
                        this.del2();
                        this.boxEx = false;
                    }else{
                        this.appIDX = res.data.appidx
                        this.strReady = res.data.strread
                        this.titleNameKey = res.data.titlename
                        if(this.appIDX == ''&&this.strReady == ''&&this.titleNameKey == ''){
                            this.$notify({
                                message: '创建实验有误，请联系管理员',
                                type: 'error',
                                duration: 1500
                            })
                            this.eduIdz = 0
                            this.eduIdj = 0
                            this.exName = ''
                            this.filedR.label = 0
                            this.filedR2.label = 0
                            this.nums = 0;
                            this.nums2 = 0;
                            this.del();
                            this.del2();
                            this.boxEx = false;
                        }else{
                            let syName = {}
                            syName.syname = this.exName
                            syName.syuserid = this.userId
                            syName.syModular = this.modular
                            syName.isStudy = 2
                            if(this.indexparent == '' || this.indexparent == undefined || this.indexparent == null){
                                syName.sypid = 0
                            }else{
                                syName.sypid = this.indexparent.pop().id
                            }
                            request({
                                method:'post',
                                url:'api/addJdSylistinfo?'+'appIDX='+this.appIDX+'&chapterIds='+this.nums2+'&strReady='+encodeURIComponent(this.strReady)+'&titleNameKey='+this.titleNameKey+'&treeIds='+this.nums+'&isStudy=2',
                                data:syName
                            }).then(res=>{
                                if(res.code == 400){
                                    this.$notify({
                                        message: '创建实验有误，请联系管理员',
                                        type: 'error',
                                        duration: 1500
                                    })
                                    this.eduIdz = 0
                                    this.eduIdj = 0
                                    this.filedR.label = 0
                                    this.filedR2.label = 0
                                    this.nums = 0;
                                    this.nums2 = 0;
                                    this.del();
                                    this.del2();
                                    this.exName = ''
                                    this.boxEx = false;
                                    this.modular = '1'
                                }else{
                                    this.$notify({
                                        message: '创建实验成功,正在为您打开',
                                        type: 'success',
                                        duration: 1500
                                    })
                                    this.loading = false;
                                    this.getList3();
                                    this.del();
                                    this.del2();
                                    this.filedR.label = 0
                                    this.filedR2.label = 0
                                    this.nums = 0;
                                    this.nums2 = 0;
                                    this.exName = ''
                                    this.boxEx = false;
                                    this.modular = '1';
                                    if(res.data.isStudy == 2){
                                        this.userState = 1
                                        this.syID = res.data.id
                                        this.userId = this.userId
                                        this.exName2 = res.data.syname
                                        this.modularBarU = res.data.syModular
                                        this.ExIsStudy = res.data.isStudy
                                        this.getEx()
                                        setTimeout(() => {
                                            this.unityex = true
                                        }, 500)
                                    }
                                }
                            })
                        }
                    }
                })
            }
          }
        },
        // 关闭实验框
        closea(){
            this.boxEx = false
            this.eduIdz = 0
            this.eduIdj = 0
            this.filedR.label = 0
            this.filedR2.label = 0
            this.nums = 0;
            this.nums2 = 0;
            this.del();
            this.del2();
            this.exName = '';
            this.loading = false
        },
        //获取info
        getinfo(){
          request({
            method:'get',
            url:'auth/info'
          }).then(res=>{
            this.userVIP = res.jwtUser.userVIP
            if(res.userSubject == null){
                this.swit = true
                this.swit2 = false
                this.inpu = true
                this.inpu2 = false
                this.pagin = true
                this.pagin2 = false
                this.userId = res.jwtUser.id
                this.getProp()
                this.infoNumber = 0
                this.getList3()
            }else{
                if(res.userSubject.type == 0){
                    this.swit = true
                    this.swit2 = false
                    this.inpu = true
                    this.inpu2 = false
                    this.pagin = true
                    this.pagin2 = false
                    this.userId = res.jwtUser.id
                    // this.eduId = res.userSubject.treeId
                    // this.eduName = res.userSubject.nodeNames
                    this.infoNumber = 0
                    this.getProp()
                    this.getList()
                }else if(res.userSubject.type == 1){
                    this.swit = false
                    this.swit2 = true
                    this.inpu = false
                    this.inpu2 = true
                    this.pagin = false
                    this.pagin2 = true
                    this.userId = res.jwtUser.id
                    // this.eduId = res.userSubject.treeId
                    // this.eduName = res.userSubject.nodeNames
                    this.infoNumber = 1
                    this.getProp()
                    this.getList2()
                }
            }
          })
        },
        //按知识点
        Rescreening(){
            this.$confirm('您是否要重置搜索内容？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            cancelButtonClass: 'messageBox-btnF',
            confirmButtonClass: 'messageBox-btnT',
            type: 'warning',
            }).then(() => {
                this.search = '';
                let page = {}
                page.pagesize = 12;
                page.pagenumber = 0;
                page.currentPage = 1;
                page.total = 0;
                page.search = '';
                this.pageData =page
                this.getList3()
            }).catch(() => {      
            });
        },
        // 按章节
        Rescreening2(){
            this.$confirm('您是否要重置搜索内容？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            cancelButtonClass: 'messageBox-btnF',
            confirmButtonClass: 'messageBox-btnT',
            type: 'warning',
            }).then(() => {
                this.search = '';
                let page = {}
                page.pagesize = 12;
                page.pagenumber = 0;
                page.currentPage = 1;
                page.total = 0;
                page.search = '';
                this.pageData =page
                this.getList3()
            }).catch(() => {      
            });
        },
        //按知识点
        searchto(){
            var specialKey = "[`@~!#$^&*()=|%{}':;',[].<>/~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'";
            for(var i = 0;i<specialKey.length;i++){
                if(this.search == specialKey[i]){
                    this.$notify({
                        message:"此为非法字符，请确认后输入",
                        type:'error',
                        duration: 1500
                    })
                    return
                }
            }
            this.pageData.pagenumber = 0;
            this.getList3();
        },
        //按章节
        searchto2(){
            var specialKey = "[`@~!#$^&*()=|%{}':;',[].<>/~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'";
            for(var i = 0;i<specialKey.length;i++){
                if(this.search == specialKey[i]){
                    this.$notify({
                        message:"此为非法字符，请确认后输入",
                        type:'error',
                        duration: 1500
                    })
                    return
                }
            }
            this.pageData.pagenumber = 0;
            this.getList3();
        },
        //按知识点搜索
        switcs(value){
          if(value == "全部"){
              this.isfree = ''
          }else{
              this.isfree = 0
          }
          this.pageData.total = 0;
          this.pageData.pagenumber = 0;
          this.getList()
        },
        //按章节搜索
        switcs2(value){
          if(value == "全部"){
              this.isfree = ''
          }else{
              this.isfree = 0
          }
          this.pageData.total = 0;
          this.pageData.pagenumber = 0;
          this.getList2()
        },
        offAllListen(){
            this.bus.$off("switcG")
            this.bus.$off("switcG2")
            this.bus.$off("ificationG")
            this.bus.$off("ificationG2")
            this.bus.$off("ificationG3")
        },
        getProp(){
            // 标签
            // this.bus.$on("myFun1g",prop=>{
            // this.themeType = prop;
            // this.getList()
            // })
            //特色实验
            // this.bus.$on("myFun2",prop=>{
            // this.materialType = prop;
            // this.getList()
            // })
            this.bus.$on("switcG",prop=>{
                this.eduId = '';
                this.eduName = '';
                this.pageData.total = 0;
                this.pageData.pagenumber = 0;
                this.infoNumber = 0
                this.noderes = 0
                this.getList()
            })
            this.bus.$on("switcG2",prop=>{
                this.eduId = '';
                this.eduName = '';
                this.pageData.total = 0;
                this.pageData.pagenumber = 0;
                this.infoNumber = 1
                this.noderes = 1
                this.getList2()
            })
            //按知识点
            this.bus.$on("ificationG",prop=>{
                this.eduId = prop.id;
                this.eduName = prop.nodename
                this.pageData.pagenumber = 0;
                this.page = 1;
                this.pagin = true;
                this.pagin2 = false;
                this.noderes = 0
                this.getList()
            })
            //按章节
            this.bus.$on("ificationG2",prop=>{
                this.eduId = prop.id;
                this.eduName = prop.nodename
                this.pageData.pagenumber = 0;
                this.page = 1;
                this.pagin = false;
                this.pagin2 = true;
                this.noderes = 1
                this.getList2()
            })
            this.bus.$on("ificationG3",prop=>{
                this.eduId = prop.id;
                this.eduName = prop.nodename
                this.pageData.pagenumber = 0;
                this.page = 1;
                this.pagin = true;
                this.pagin2 = false;
                this.noderes = 0
                this.getList()
            })
            this.bus.$on("allEx",prop=>{
                this.changeNum = prop
            })
            this.bus.$on("knowledgeEx",prop=>{
                this.changeNum = prop
            })
            this.bus.$on("chapterEx",prop=>{
                this.changeNum = prop
            })
        },
        // 获取所有
        getList3(type){
            this.isTable = 97
            this.bus.$emit("allEx", 0)
            this.inpu = true
            this.inpu2 = false
            this.swit = true
            this.swit2 = false
            this.pagin = true
            this.pagin2 = false
            this.loading = true
            request({
                 method:'get',
                 url: 'api/jdSylistinfo?'+'page='+this.pageData.pagenumber+'&eduTreeIds='+this.eduId+'&size='+this.pageData.pagesize+'&syuserid='+this.userId+'&noderes='+'&syname='+this.search+'&userCollect=0'+'&syModular='+this.modularBar+'&recycle=0'+'&id='+this.folderId+"&sort=sytypeid,desc"+"&sort=id,desc"
            }).then(res=>{
                this.indexparent = res.data.indexparent;
                let changeimg = res.data.content;
                this.imageChanges = [];
                for(let i in changeimg){
                    if(changeimg[i].sypicpath == '' || changeimg[i].sypicpath == null){
                        changeimg[i].sypicpath = '../../assets/images/portal/nophoto.png';
                        this.imageChanges.push((changeimg[i].sypicpath.split("").reverse().join("").substring(4)).split("").reverse().join("")+'_480x270.png')
                    }else{
                        this.imageChanges.push((changeimg[i].sypicpath.split("").reverse().join("").substring(4)).split("").reverse().join("")+'_480x270.png')
                    }
                }
                this.itemOK = true
                this.dataList = res.data.content;
                if(res.data.content == '' && res.data.totalElements == 0){
                    this.itemOk = true
                    return;
                }else if(res.data.content == '' && res.data.totalElements != 0){
                    let _this = this
                    _this.pageData.pagenumber = 0;
                    _this.page = 0;
                    _this.getList3()
                }else{
                    var temp = {}
                    temp.pagesize=this.pageData.pagesize;
                    temp.pagenumber=this.pageData.pagenumber;
                    temp.total =Number(res.data.totalElements);
                    this.pageData=temp
                }
                this.loading = false
                // 滚动到顶部
                let currentPosition,timer;
                let speed=30;
                setTimeout(() => {
                    timer=setInterval(function(){
                        currentPosition=document.documentElement.scrollTop || document.body.scrollTop;
                        currentPosition-=speed;
                        if(currentPosition>0){
                            window.scrollTo(0,currentPosition);
                        }else{
                            window.scrollTo(0,0);
                            clearInterval(timer);
                        }
                    },1);
                }, 100)

            })
        },
        //通过知识点获取
        getList(type){
            this.isTable = 99
            this.bus.$emit("knowledgeEx", 1)
            this.inpu = true
            this.inpu2 = false
            this.swit = true
            this.swit2 = false
            this.pagin = true
            this.pagin2 = false   
            this.loading = true
            request({
                 method:'get',
                 url: 'api/jdSylistinfo?'+'page='+this.pageData.pagenumber+'&eduTreeIds='+this.eduId+'&size='+this.pageData.pagesize+'&syuserid='+this.userId+'&noderes=0'+'&syname='+this.search+'&userCollect=0'+'&syModular='+this.modularBar+'&recycle=0'+'&id='+this.folderId+"&sort=sytypeid,desc"+"&sort=id,desc"
            }).then(res=>{
                this.indexparent = res.data.indexparent;
                let changeimg = res.data.content;
                this.imageChanges = [];
                for(let i in changeimg){
                    if(changeimg[i].sypicpath == '' || changeimg[i].sypicpath == null){
                        changeimg[i].sypicpath = '../../assets/images/portal/nophoto.png';
                        this.imageChanges.push((changeimg[i].sypicpath.split("").reverse().join("").substring(4)).split("").reverse().join("")+'_480x270.png')
                    }else{
                        this.imageChanges.push((changeimg[i].sypicpath.split("").reverse().join("").substring(4)).split("").reverse().join("")+'_480x270.png')
                    }
                }
                this.itemOK = true
                this.dataList = res.data.content;
                if(res.data.content == '' && res.data.totalElements == 0){
                    this.itemOk = true
                    return;
                }else if(res.data.content == '' && res.data.totalElements != 0){
                    let _this = this
                    _this.pageData.pagenumber = 0;
                    _this.page = 0;
                    _this.getList()
                }else{
                    var temp = {}
                    temp.pagesize=this.pageData.pagesize;
                    temp.pagenumber=this.pageData.pagenumber;
                    temp.total =Number(res.data.totalElements);
                    this.pageData=temp
                }
                this.loading = false
                // 滚动到顶部
                let currentPosition,timer;
                let speed=30;
                setTimeout(() => {
                    timer=setInterval(function(){
                        currentPosition=document.documentElement.scrollTop || document.body.scrollTop;
                        currentPosition-=speed;
                        if(currentPosition>0){
                            window.scrollTo(0,currentPosition);
                        }else{
                            window.scrollTo(0,0);
                            clearInterval(timer);
                        }
                    },1);
                }, 100)

            })
        },
        //通过章节获取
        getList2(type){
            this.isTable = 98
            this.bus.$emit("chapterEx", 2)
            this.inpu = false
            this.inpu2 = true
            this.swit = false
            this.swit2 = true
            this.pagin = false
            this.pagin2 = true
            this.loading = true
            request({
                 method:'get',
                 url: 'api/jdSylistinfo?'+'page='+this.pageData.pagenumber+'&eduTreeIds='+this.eduId+'&size='+this.pageData.pagesize+'&syuserid='+this.userId+'&noderes=1'+'&syname='+this.search+'&userCollect=0'+'&syModular='+this.modularBar+'&recycle=0'+'&id='+this.folderId+"&sort=sytypeid,desc"+"&sort=id,desc"
            }).then(res=>{
                this.indexparent = res.data.indexparent;
                let changeimg = res.data.content;
                this.imageChanges = [];
                for(let i in changeimg){
                    if(changeimg[i].sypicpath == '' || changeimg[i].sypicpath == null){
                        changeimg[i].sypicpath = '../../assets/images/portal/nophoto.png';
                        this.imageChanges.push((changeimg[i].sypicpath.split("").reverse().join("").substring(4)).split("").reverse().join("")+'_480x270.png')
                    }else{
                        this.imageChanges.push((changeimg[i].sypicpath.split("").reverse().join("").substring(4)).split("").reverse().join("")+'_480x270.png')
                    }
                }
                this.itemOK = true
                this.dataList = res.data.content;
                if(res.data.content == '' && res.data.totalElements == 0){
                    this.itemOk = true
                    return;
                }else if(res.data.content == '' && res.data.totalElements != 0){
                    let _this = this
                    _this.pageData.pagenumber = 0;
                    _this.page = 0;
                    _this.getList2()
                }else{
                    var temp = {}
                    temp.pagesize=this.pageData.pagesize;
                    temp.pagenumber=this.pageData.pagenumber;
                    temp.total =Number(res.data.totalElements);
                    this.pageData=temp
                }
                this.loading = false
                // 滚动到顶部
                let currentPosition,timer;
                let speed=30;
                setTimeout(() => {
                    timer=setInterval(function(){
                        currentPosition=document.documentElement.scrollTop || document.body.scrollTop;
                        currentPosition-=speed;
                        if(currentPosition>0){
                            window.scrollTo(0,currentPosition);
                        }else{
                            window.scrollTo(0,0);
                            clearInterval(timer);
                        }
                    },1);
                }, 100)
                
            })
        },
        pageChange(data){
            this.pageData.pagenumber = data-1;
            this.getList3()
        },
        pageChange2(data){
            this.pageData.pagenumber = data-1;
            this.getList2()
        },
    }
    
}
</script>

<style scoped>
    @import '../styles/pad.css';
    @import '../styles/search.css';
    .ReNameExs /deep/ .el-input__inner{
        padding: 0;
        border: none;
        border-radius: unset;
        color: rgba(51, 51, 51, 1);
        padding: 3px 0;
        height: unset;
        line-height: unset;
        font-size: 16px;
    }
    .ReNameExs{
        width: 90%;
        float: left;
        border-bottom: 1px solid #2174ff;
    }
    .folderR{
        float:left;
        width:100%;
        padding:0;
        margin-top:7px;
        list-style: none;
    }
    .folderR li{
        text-align:left;
        color:#666666;
        float:left;
    }
    .transition-box /deep/ .el-tree-node__content:hover{
        background-color: #EEEEEE;
    }
    .transition-box /deep/ .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
        background-color: #EEEEEE;
        color: #2174ff;
    }
.el-dropdown{
    float:right;
    margin: 0 5px 0 0;
    cursor: pointer;
    margin-top: 15px;
}
.list /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color: #2174ff;
    border-color: #2174ff;
}
.list /deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
    color:#2174ff;
}
.unitybox{
    width:100%;
    height: 100%;
    position: fixed;
    left: 0;
    top:0;
    bottom:0;
    right:0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 4000;
}
.unitybox p{
    position: absolute;
    top:0;
    right:0;
    margin:0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 1000;
    color:#fff;font-size:50px;
}
#unitybox{
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 2001;
}
#ifrunity{
    width:100%;
    height: 100%;
}
#buttombox{
    position: absolute;
    top: 0;
    right: -51px;
    width: 51px;
    height: auto;
}
#full{
    float:left;
    margin: 0;
    padding:5px 15px 3px 15px;
    font-size:20px;
    background: rgba(0, 0, 0, 0.2);
    text-align: center;
    color:#fff;
    z-index: 200;
}
#closeun{
    float:left;
    margin: 0;
    padding:5px 16px 3px 16px;
    font-size:20px;
    background: rgba(0, 0, 0, 0.2);
    text-align: center;
    color:#fff;
    z-index: 200;
    cursor: pointer;
    border-bottom:2px solid #eee;
}
.Experimentlist{
    width: 100%;height: 100%;background: #fff;
    float:left;
}
.contentl{
    width:98%;
    border-bottom: 1px solid #eee;
    height: 65px;
    margin-left: 1%;
    margin-bottom: 10px;
}
.tit{
    margin: 0;
    line-height: 65px;
    font-size: 20px;
    font-weight: 400;
    float: left;
    color: #333;
}
.rowtab2{
    float: left;
    font-size: 14px;
    margin-top: 32px;
    margin-left: 805px;
}
.buttontab2{
    height: 14px;
    padding-right: 10px;
    border-right: 1px solid #ccc;
}
.buttontab2:last-of-type{
    padding-left: 5px;
    border-right: none;
    padding-right: 0;
}
.contentl>ul{
    height: 65px;
    line-height: 65px;
    margin: 0;
    padding: 0;
    list-style: none;
    padding: 0 126px;
    float: right;
}
.contentl>ul>li{
    width: auto;
    float: left;
    margin: 0;
    padding: 0;
    list-style: none;
}
.list{
    width: 100%;
    height: 100%;
    float:left;
}
.item{
    /* width:30%; */
    float: left;
    margin-bottom: 20px;
    z-index: 10;
}
.itemIn{
    width:100%;
    float: left;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
}
.itemIn:hover{
    transition: all 0.2s linear 0s;
    transform: scale(1.01);
    box-shadow: 4px 7px 18px 0px rgba(0, 0, 0, 0.2);
}
.itemIn:hover .collection{
    display: block;
}
.pic{
    width: 100%;
    text-align: center;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    height:calc( (23.1vw / 16) * 9);
    background: #979693b8;
}
.pic /deep/ .el-image{
    width:100%;
    height: 100%;
    float:left;
}
.pic img{
    width:100%;
    height: 100%;
}
.pick{
    margin: 0;
    color:#666;
    float:left;
    width:100%;
    margin-bottom:10px;
}
.startgame{
    padding: 10px 15px;
    background-color:#2174ff;
    font-size: 18px;
}
.startgameS{
    padding: 10px 15px;
    background-color:#ec6f28;
    font-size: 18px;
}
.upstrata{
    z-index: 2;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    margin: 0;
    display: none;
}
.itemIn:hover .upstrata{
    display: block;
}
.itemIn:hover .upstrataS{
    display: block;
}
.itemIn:hover .upstrata{
    animation:mymove2 0.4s;
    animation-fill-mode: forwards;
}
.pic /deep/ .el-button--text{
    color: #fff;
}
.pic /deep/ .el-button:hover{
    background-color: rgb(241, 173, 78);
    color: #fff;
}
.upstrataS{
    z-index: 1;
    display: none;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    margin: 0;
    animation:mymove 0.4s;
    animation-fill-mode: forwards;
}
@keyframes mymove{
    from {left:50%;}
    to {left:66%;}
}
@keyframes mymove2{
    from {left:50%;}
    to {left:34%;}
}
/* 同步 探究 */
.tbtj{
    width: 14%;
    height: 30px;
    line-height: 30px;
    background-color: #2174ff;
    border-radius: 2px;
    position: absolute;
    left: 3%;
    top: 5%;
    color: #E8E8E8;
    font-size: 18px;
}
.left-top{
    font-weight: 400;
}
/* 收藏 */
.collection{
    width: 12%;
    height: 14.5%;
    position: absolute;
    right: 3%;
    top: 5%;
    background: #fff;
    padding: 8px;
    border-radius: 4px;
    display: none;
    cursor: pointer;
}
.list /deep/ .image-slot{
    width:100%;
    height:100%;
    float: left;
}
.collection-2{
    width: 100%;
    height: 100%;
    background-image: url(../../assets/images/portal/collection2.png) !important;
    background-size: 100%;
    animation: spin 0.5s ease-in-out;
}
@keyframes spin {
                0%{
                    transform: scale(1);  /*开始为原始大小*/
                }
                100% {
                    transform: scale(1.1);
                }
            }
.collection>i{
    float: left;
    width: 100%;
    height: 100%;
}
.collectioni{
    width: 100%;
    height: 100%;
    background-image: url(../../assets/images/portal/collection.png);
    background-size: 100%;
}
.box3{
    background-color: #00A0E9;
}
/* 收费 免费 */
.box{
    width: 0;
    height: 0;
    border-top: 60px solid  #46b8da;
    border-left: 60px solid transparent;
    margin-bottom: -100px;
    position: absolute;
    right: 0;
    top: 0;
    float: right !important;
    box-sizing: border-box;
    z-index: 200;
}
.box2{
    border-top: 60px solid  #f19345;
}
.right-top{
    width: 60px;
    font-weight: 600;
    color: #fff;
    position: relative;
    right: 50px;
    top: -50px;
    display: block;
    box-sizing: border-box;
    /* transform: rotate(80deg); */
    -webkit-transform:rotate(45deg)
}

.titl{
    padding-top: 4%;
    padding-left: 2%;
    font-size: 16px;
    color: #333;
    font-weight: 400;
    width: 60%;
    margin: 0;
    float:left;
    white-space:nowrap; text-overflow:ellipsis; -o-text-overflow:ellipsis; overflow:hidden;
}

/* new */
.Exinput{
    margin-top: 7px;
    border-radius: 2px;
}
.Exinput /deep/ .el-input__inner{
    height: 32px;
    border-color: #ccc;
}
.boxxx{
    position: fixed;
    left: 0;
    right: 0;
    top:0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .4);
    z-index:2000;
}
.transition-box{
    width: 420px;
    position:absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    padding: 12px 14px 14px 14px;
    overflow: hidden;
    overflow-y: auto;
    border-radius: 4px;
}
.head{
    text-align: center;
    position: relative;
    font-size: 18px;
    color: #333;
    margin-bottom: 14px;
}
.head p{
    float:right;
    margin: 0;
    cursor: pointer;
}
.content{
    width: 100%;
    float: left;
}
.content>ul{
    margin: 0;
    padding: 0;
    float: left;
}
.content>ul>li{
    list-style: none;
    float: left;
    margin-bottom: 15px;
    color: #333;
    width:100%;
    font-size: 14px;
}
.content>ul>li:nth-of-type(2) /deep/ .el-radio-group{
    margin-top: 8px;
}
.content /deep/ .joinEx{
    color:#2174ff;
    font-size: 14px;
    border: none;
    padding: 0;
}
.content>ul>li:nth-of-type(3) .joinEx{
    margin-left: 15px;
}
.content>ul>li:nth-of-type(3) .joinEx .el-icon-plus{
    font-weight: bold;
}
.content>ul>li:nth-of-type(3) .joinEx:focus, .joinEx:hover{
    border-color: #2174ff;
    color:#2174ff;
    background-color: #fff;
    border-radius: 2px;
}
.content>ul>li:nth-of-type(4) .joinEx{
    margin-left: 15px;
}
.content>ul>li:nth-of-type(4) .joinEx .el-icon-plus{
    font-weight: bold;
}
.content>ul>li:nth-of-type(4) .joinEx:focus, .joinEx:hover{
    border-color: #2174ff;
    color:#2174ff;
    background-color: #fff;
    border-radius: 2px;
}
.content>ul>li:last-of-type{
    width: 100%;
    text-align: center;
    margin-bottom: 0;
}
.content /deep/ .el-button--warning{
    font-size: 14px !important;
    color: #fff !important;
    padding:8px 30px !important;
    background-color:#2174ff;
}
.content /deep/ .el-cascader .el-input.is-focus .el-input__inner{
    border-color: #2174ff;
}
.content /deep/ .el-cascader{
    width: 88%;
    margin-top: 8px;
}
.content /deep/ .el-cascader .el-input__inner{
    height: 32px;
    border-radius: 2px;
}
.content /deep/ .el-button--text{
    border:none;
    padding: 5px 0;
}
.content /deep/ .el-radio.is-bordered.is-checked{
    border-color: #2174ff;
    border: 2px solid #2174ff;
    background: url(../../assets/images/portal/gou.png) no-repeat 95% 100%;
}
/* 实验模块栏 */
.modularBar /deep/ .el-radio.is-bordered.is-checked{
    border-color: #2174ff;
    border: 2px solid #2174ff;
}
.modularBar /deep/ .el-radio__input.is-checked+.el-radio__label{
    color: #2174ff;
}
.content /deep/ .el-radio.is-bordered{
    border-color:#ccc;
}
.content /deep/ .el-radio--mini.is-bordered{
    padding: 8px 20px;
    height:auto;
}
.content /deep/ .el-radio--mini.is-bordered .el-radio__label, .el-radio--small.is-bordered .el-radio__label{
    font-size: 14px;
    color: #333;
    padding: 0;
}
.content /deep/ .el-radio__input.is-checked+.el-radio__label{
    color: #2174ff;
    padding: 0;
}
.content /deep/ .el-radio{
    margin-right: 7px;
}
.content /deep/ .el-radio.is-bordered+.el-radio.is-bordered{
    margin-left: 7px;
}
.content /deep/ .el-radio__input{
    display: none;
}
.el-rate{
    float: right;
    color:rgb(236, 111, 40)
}
.paginations{
    width: 100%;
    float: left;
    padding: 18px 20px;
}
.el-pagination{
    text-align: center;
    font-weight: 400;
}
/* 提示信息 */
.noshow{
    height: auto;
    text-align: center;
    margin-top: 166px;
}
.noshow>span{
    font-size: 32px;
    color: #999;
}
.noshow>p{
    margin-top: 69px;
    margin-bottom: 158px;
    width: 593px;
    height: 349px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
}
.noshow>p>img{
    width: 100%;
    height: 100%;
}
.isRecomm{
    width: 18px;
    height: 20px;
    float: left;
    margin-right: 9px;
    background-image: url(../../assets/images/portal/hot.png);
    background-size: 100%;
}
.image-slot{
    width: 100%;
    height: 100%;
    float: left;
}
    @media (max-width: 1024px){
        .startgame{
            padding: 14px 4px !important;
            background-color:#2174ff !important;
            font-size: 12px !important;
        }
        .startgameS{
            padding: 14px 4px !important;
            background-color:#ec6f28 !important;
            font-size: 12px !important;
        }
        @keyframes mymove{
            from {left:50%;}
            to {left:70%;}
        }
        @keyframes mymove2{
            from {left:50%;}
            to {left:30%;}
        }
        /* .itemIn:hover .upstrata,.upstrataS{
            display: block;
        }
        .upstrataS{
            width: 50%;
            display: block;
            animation:unset !important;
            left: unset !important;
            right: 0;
            top: 0;
            transform: unset !important;
            background-color:#eee;
            opacity: .2;
        }
        .upstrata{
            width: 50%;
            display: block;
            animation:unset !important;
            left: 0;
            top: 0;
            transform: unset !important;
            background-color:#eee;
            opacity: .2;
        }
        .startgame{
            height:calc( (23.1vw / 16) * 9);
            font-size: 14px;
            background-color:#eee;
            border-radius: unset !important;
        }
        .startgameS{
            height:calc( (23.1vw / 16) * 9);
            font-size: 14px;
            background-color:#eee;
            border-radius: unset !important;
        } */
    }
  @media screen and (min-width:1025px) and (max-width:1366px){
    .break{
        display:none;
    }
    .rowtab2{
        float: left;
        margin-left: 20px;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    .unitybox p{
        position: absolute;
        top:0;
        right:0;
        margin:30px;
        margin-top: 70px;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1000;
    }
    #bo{
        position: relative;
        left: 50%;
        top: 50%;
        right: 0;
        bottom: 0;
        transform: translateX(-50%) translateY(-50%);
        width:960px;
        height:540px;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 95px;
    }
    .noshow>span{
        font-size: 24px;
        color: #999;
    }
    .noshow>p{
        margin-top: 49px;
        margin-bottom: 62px;
        width: 422px;
        height: 248px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#2174ff;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #2174ff;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #2174ff;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
  @media screen and (min-width:1367px) and (max-width:1440px){
    .rowtab2{
        position: absolute;
        left: 200px;
        font-size: 14px;
        margin-top: 32px;
        margin-left: 710px;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        float: right;
    }
    .pick p:nth-of-type(1){
        width:56%;
        float: left;
        padding:6% 0;
        margin: 0;
        font-size: 16px;
        color:#666;
    }
    .pick p:nth-of-type(2){
        width: 44%;
        float: left;
        padding:6% 0;
        margin: 0;
        font-size: 16px;
        color:#666;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    .unitybox p{
        position: absolute;
        top:0;
        right:0;
        margin:30px;
        margin-top: 70px;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1000;
    }
    #bo{
        position: relative;
        left: 50%;
        top: 50%;
        right: 0;
        bottom: 0;
        transform: translateX(-50%) translateY(-50%);
        width:960px;
        height:540px;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 95px;
    }
    .noshow>span{
        font-size: 24px;
        color: #999;
    }
    .noshow>p{
        margin-top: 49px;
        margin-bottom: 62px;
        width: 422px;
        height: 248px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#2174ff;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #2174ff;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #2174ff;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
  @media screen and (min-width:1441px) and (max-width:1600px){
    .rowtab2{
        position: absolute;
        left: 200px;
        font-size: 14px;
        margin-top: 32px;
        margin-left: 860px;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    .unitybox p{
        position: absolute;
        top:0;
        right:0;
        margin:30px;
        margin-top: 70px;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1000;
    }
    #bo{
        position: relative;
        left: 50%;
        top: 50%;
        right: 0;
        bottom: 0;
        transform: translateX(-50%) translateY(-50%);
        width:1120px;
        height:630px;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 117px;
    }
    .noshow>span{
        font-size: 26px;
        color: #999;
    }
    .noshow>p{
        margin-top: 55px;
        margin-bottom: 96px;
        width: 474px;
        height: 279px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#2174ff;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #2174ff;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #2174ff;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
  @media screen and (min-width:1601px) and (max-width:1920px){
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        float: right;
    }
    .rowtab2{
        position: absolute;
        left: 600px;
        font-size: 14px;
        margin-top: 32px;
        margin-left: 805px;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    .unitybox p{
        position: absolute;
        top:0;
        right:0;
        margin-right:10%;
        margin-top:100px;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1000;
        color:#fff;font-size:50px;
    }
    #bo{
        position: relative;
        left: 50%;
        top: 50%;
        right: 0;
        bottom: 0;
        transform: translateX(-50%) translateY(-50%);
        width:1280px;
        height:720px;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 166px;
    }
    .noshow>span{
        font-size: 32px;
        color: #999;
    }
    .noshow>p{
        margin-top: 69px;
        margin-bottom: 158px;
        width: 593px;
        height: 349px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#2174ff;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #2174ff;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #2174ff;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
  @media screen and (min-width:1921px) and (max-width:2048px){
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    .unitybox p{
        position: absolute;
        top:0;
        right:0;
        margin:30px;
        margin-top: 70px;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1000;
    }
    #bo{
        position: relative;
        left: 50%;
        top: 50%;
        right: 0;
        bottom: 0;
        transform: translateX(-50%) translateY(-50%);
        width:1280px;
        height:720px;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 182px;
    }
    .noshow>span{
        font-size: 34px;
        color: #999;
    }
    .noshow>p{
        margin-top: 74px;
        margin-bottom: 122px;
        width: 633px;
        height: 372px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#2174ff;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #2174ff;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #2174ff;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
  @media (min-width:2049px){
    .paginations{
        padding: 40px 0;
    }
    .rowtab2{
        position: absolute;
        left: 1150px;
        font-size: 14px;
        margin-top: 32px;
        margin-left: 805px;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    .unitybox p{
        position: absolute;
        top:0;
        right:0;
        margin:30px;
        margin-top: 70px;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1000;
    }
    #bo{
        position: relative;
        left: 50%;
        top: 50%;
        right: 0;
        bottom: 0;
        transform: translateX(-50%) translateY(-50%);
        width:1760px;
        height:990px;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 248px;
    }
    .noshow>span{
        font-size: 44px;
        color: #999;
    }
    .noshow>p{
        margin-top: 92px;
        margin-bottom: 246px;
        width: 791px;
        height: 465px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#2174ff;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #2174ff;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #2174ff;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
    [v-cloak] {
        display: none;
    }
</style>

<style rel="stylesheet/scss" lang="scss">
    .el-message{
        z-index: 2004 !important;
    }
    .page-login-toolTipClass{
        background-color: rgba($color: #333, $alpha: 0.5) !important;
        color: #fff;
        border:none !important;
    }
    .el-tooltip__popper[x-placement^=right] .popper__arrow::after {
        border-right-color: rgba($color: #333, $alpha: 0.5) !important;
    }
    .el-tooltip__popper[x-placement^=right] .popper__arrow{
        border-right-color: rgba($color: #333, $alpha: 0.5) !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/myComponentsEv/shiyanListEv.vue